<a *ngIf="type == 'help'">
	<i class="font-size-21" class="material-icons" [matTooltip]="text" [matTooltipPosition]="position">help</i>
</a>

<a *ngIf="type == 'info'">
	<i class="fas fa-info-circle gray-text" [matTooltip]="text" [matTooltipPosition]="position"></i>
</a>

<a *ngIf="type == 'info-banner'">
	<i
		class="mb-2 fas fa-info-circle gray-text"
		[matTooltip]="text"
		[matTooltipPosition]="position"
	></i>
</a>
